var MaintenanceTypeSearchComponentModule = /** @class */ (function () {
    function MaintenanceTypeSearchComponentModule() {
    }
    return MaintenanceTypeSearchComponentModule;
}());
export { MaintenanceTypeSearchComponentModule };
